<template>
    <div>
        <button class="btn btn-link" @click="switchNextState">
            <span v-show="modelValue === 0">
                <i class="fa fa-sort"> </i>
            </span>
            <span v-show="modelValue === 1">
                <i class="fa fa-sort-up"> </i>
            </span>
            <span v-show="modelValue === 2">
                <i class="fa fa-sort-down"> </i>
            </span>
        </button>
    </div>
</template>

<script>

    const sortStates = [
        {
            type: 'none',
            prefix: ''
        },
        {
            type: 'ascending',
            prefix: ''
        },
        {
            type: 'descending',
            prefix: '-'
        }
    ];

    export default {
        name: "DataTableOrdering",
        props: {
            columnName: { type: String },  // имя колонки в таблице
            fieldName: { type: String, default: null },  // имя поля в БД, которое оно сортирует
            state: { default: 0 }
        },
        model: {
            prop: 'state',
            event: 'state-changed'
        },
        computed: {
            modelValue: {
                get: function () {
                    return this.state
                },
                set: function (value) {
                    this.$emit('state-changed', value, this.columnName, this.fieldName)
                }
            }
        },
        methods: {
            getNextStateIndex() {
                const newIndex = this.state + 1;
                return newIndex - sortStates.length * Math.floor(newIndex / sortStates.length);
            },
            switchNextState() {
                this.modelValue = this.getNextStateIndex();
            },
        },
    }
</script>

<style scoped>

</style>